<template>
  <div class="page A4Landscape" :style="pageBackgroundStyle">
    <header ref="header" class="print-page-landscape__header">
      <slot name="header"></slot>
    </header>
    <main ref="main" class="print-page-landscape__main">
      <slot></slot>
    </main>
    <div v-if="showPageNumber" class="pageNumber">
      <template v-if="pageCount">
        {{ $t('printPageFooterCurrentOfTotal', { current: pageNumber, total: pageCount }) }}
      </template>
      <template v-else>
        {{ $t('printPageFooterCurrent', { current: pageNumber }) }}
      </template>
    </div>
  </div>
</template>

<script>
/**
 * DIN A4 landscape print shell — mirror of PrintPage.vue with swapped dimensions and optional full-bleed background.
 */
export default {
  name: 'PrintPageLandscape',

  props: {
    /** When false, hides the footer page indicator. */
    showPageNumber: { type: Boolean, default: false },
    /** Kept for API parity with PrintPage.vue — not used in the template there either. */
    showOVerallPageCount: { type: Boolean, default: false },
    pageNumber: { type: [Number, String], default: 1 },
    pageCount: { default: null },
    /** Public URL path (e.g. /img/short-teaser/slide-1.jpg) — full bleed via background-size cover. */
    backgroundImageUrl: { type: String, default: '' },
  },

  computed: {
    pageBackgroundStyle() {
      if (!this.backgroundImageUrl) {
        return {};
      }
      return {
        backgroundImage: `url(${this.backgroundImageUrl})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/** DIN A4 landscape */
.A4Landscape {
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  width: 29.7cm;
  height: 21cm;
  display: block;
  margin: 0;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 1em;
  border: 0;
}

.page {
  position: relative;
}

.print-page-landscape__header,
.print-page-landscape__main {
  position: relative;
  z-index: 1;
}

.pageNumber {
  position: absolute;
  bottom: 0.5cm;
  right: 1cm;
  z-index: 2;
}

@page {
  size: A4 landscape;
  margin: 0;
}

@media print {
  html,
  body {
    width: 297mm;
    height: 210mm;
  }

  .page {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    page-break-after: always;
    margin: 0;
    position: relative;
    width: 100%;
    height: 100%;
    font-size: 13pt;
  }

  /* Last page optional: callers can override; default keeps parity with portrait PrintPage. */
}
</style>
